import { getLanguage } from 'utils/language/language';

interface IFunctionalEndpointConfig extends types.endpoints.functionalEndpointConfig {}

const config = {
	LANGUAGE: {
		AR: '-23',
		ARABIC: '-23',
		EN: '-1',
		ENGLISH: '-1',
	},
};

const language = (config.LANGUAGE as any)[getLanguage()];

const _getRegionsByLanguage = (): string => {
	const AR_ENDPOINT = 'a36b708c-5224-4f5c-a10b-0be165de3e52';
	const EN_ENDPOINT = '3fee9688-5b6b-4855-823e-c061901a7911';
	const cmpntid = language === '-1' ? EN_ENDPOINT : AR_ENDPOINT;
	return `myconnect/omantel%20design/articles?source=library&srv=cmpnt&cmpntid=${cmpntid}&subtype=json`;
};

const _getCities = (): string => {
	return 'myconnect/omantel%20design/articles?srv=cmpnt&subtype=json&cmpntid=3453fed5-163f-4877-a9f3-005035847d4b&source=library';
};

const _asEndpoint = (url: string): types.endpoints.IEndpointConfig => {
	return {
		url,
	};
};

export const getRegions: IFunctionalEndpointConfig = () => {
	return _asEndpoint(_getRegionsByLanguage());
};

export const getCities: IFunctionalEndpointConfig = () => {
	return _asEndpoint(_getCities());
};
